import { ROLES } from "../../model/roles";
// Importa React se usi JSX in metodi come generateIconContenuti e il file è .js
// Ad esempio: import React from 'react';

export default class UtilityService {

  static isInGroup = (role = "", authRole = []) => {
    return authRole?.includes(role);
  };

  static isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  static getModalitaErogazione = (inputValue) => {
    switch (inputValue) {
        case 'Telematica_Asincrona':
            return 'Telematica asincrona';
        case 'Telematica_Sincrona':
        case 'Telematica_sincrona': // Considera se questo duplicato è intenzionale
            return 'Telematica sincrona';
        case 'Presenza':
            return 'Presenza';
        case 'Telematica_Mista':
            return 'Telematica mista';
        case 'Mista_Presenza/Telematica':
            return 'Presenza/Telematica';
        default:
            return 'Nessuna opzione';
    }
  }; // La classe NON si chiude qui

  static showAlert(message, type, duration = 5000) {
    const alertDiv = document.createElement('div');
    alertDiv.id = "notification";
    alertDiv.classList.add('alert', `alert-${type}`);
    // Per innerHTML, usa 'class' standard, non 'className' di React
    alertDiv.innerHTML = `<i class="${UtilityService.getIconClass(type)}"></i><span class="ms-2">${message}</span>`;
    document.body.appendChild(alertDiv);
    setTimeout(() => {
      const notificationElement = document.getElementById("notification");
      if (notificationElement) {
        notificationElement.remove();
      }
    }, duration);
  }

  static getIconClass(type) {
    switch (type) {
      case 'success':
        return 'bi bi-check-circle';
      case 'danger':
        return 'bi bi-exclamation-triangle';
      case 'warning':
        return 'bi bi-exclamation-triangle'; // Uguale a danger, valuta se differenziare
      default:
        return 'bi bi-info-circle';
    }
  }

  static formatDateAndHour = (data) => {
    if (data) {
        const opzioniData = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const opzioniOra = { hour: '2-digit', minute: '2-digit' };
    
        const dataFormattata = new Date(data).toLocaleDateString('it-IT', opzioniData);
        const oraFormattata = new Date(data).toLocaleTimeString('it-IT', opzioniOra);
    
        return `${dataFormattata} ${oraFormattata}`;
    }
      return null;
  };

  static formatDate = (input) => {
    if (!input) return null; // Gestisci input nullo
    const date = new Date(input);
    if (isNaN(date.getTime())) return null; // Gestisci data non valida

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const formatDay = day <= 9 ? '0' + day : day;
    const formatMonth = month <= 9 ? '0' + month : month;
    const formatDate = `${formatDay}/${formatMonth}/${date.getFullYear()}`;
    return formatDate;
  };

  static formatModalitaErogazione = (inputValue) => {
    switch (inputValue) {
        case 'asincrona':
            return 'Telematica_Asincrona';
        case 'sincrona':
            return 'Telematica_Sincrona';
        case 'presenza':
            return 'Presenza';
        case 'telematica_mista':
            return 'Telematica_Mista';
        case 'mista_presenza/telematica':
          return 'Mista_Presenza/Telematica';       
        default:
            return 'Nessun opzione'; // 'Nessuna opzione' con la 'a' se preferito
    }
  };

  static formatModalitaErogazionePerCheckbox = (inputValue) => {
    switch (inputValue) {
        case 'Telematica_Asincrona':
            return 'asincrona';
        case 'Telematica_Sincrona':
            return 'sincrona';
        case 'Presenza':
            return 'presenza';
        case 'Telematica_Mista':
          return 'telematica_mista';    
        case 'Mista_Presenza/Telematica':
          return 'mista_presenza/telematica';     
        default:
            return 'Nessun opzione'; // 'Nessuna opzione' con la 'a' se preferito
    }
  };

   static rolesAllowedToCreate = (user) => {
    switch (user?.role) {
        case ROLES.ADMIN:
        case ROLES.DEVELOPER:
            return ["superpartner", "admin", "course_designer", "docente", "partner", "tutor", "corsista"];
        
        // --- BLOCCO DA AGGIUNGERE ---
        case ROLES.SUPERPARTNER:
            return ["partner", "corsista"];
        // -----------------------------

        case ROLES.COURSE_DESIGNER:
            return ["partner"];
        case ROLES.PARTNER:
            return ["corsista"];
        default:
          return [];
    }
  };

  static getPaymentState = (state) => {
    switch (state) {
        case "Non_pagato":
            return "Non pagato";
        case "Pagato":
            return "Pagato";
        case "Parzialmente_pagato":
            return "Parzialmente pagato";
        default:
            return ""; // O un valore di default più esplicito come "Sconosciuto"
    }
  };
  
  static getBadgeColorClass = (paymentState) => { // Per stato pagamento
    switch(paymentState) {
      case 'Pagato':
        return 'text-bg-success';
      case 'Parzialmente_pagato':
        return 'text-bg-warning';
      case 'Non_pagato':
      default: // Include 'Non_pagato' e qualsiasi altro stato non mappato
        return 'text-bg-danger';
    }
  };

  // Metodi per lo STATO FATTURAZIONE
  static getBillingStatusText(status, numeroFattura) {
    switch (status?.trim()) {
      case 'Fatturato':
        // Se lo stato è "Fatturato" E abbiamo un numero di fattura, mostriamolo.
        if (numeroFattura) {
          return `Fattura n. ${numeroFattura}`;
        }
        // Altrimenti, mostriamo solo "Fatturato".
        return 'Fatturato';

      case 'Non_fatturato':
        return 'Da fatturare';

      default:
        return 'Sconosciuto';
    }
  }
  static getBillingStatusBadgeColor(status) {
    switch (status) {
      case 'Non_fatturato': // Corrisponde a "Da fatturare" nell'UI
        return 'bg-warning text-dark';
      case 'Fatturato':
        return 'bg-success text-light';
      default:
        return 'bg-secondary text-light';
    }
  }
  // Fine metodi per stato fatturazione

  static getVerificaStatusBadge(status) {
        switch (status) {
            case 'conforme':
                return { bg: 'success', text: 'Conforme' };
            case 'non_conforme':
                return { bg: 'danger', text: 'Non Conforme' };
            case 'da_verificare':
            default:
                return { bg: 'warning', text: 'Da Verificare' };
        }
    }

  static validationForm = (formData, requiredFields) => {
    if (!formData || !requiredFields) return []; // Aggiunto controllo per argomenti nulli
    return requiredFields.filter(field => {
      const value = formData[field]?.toString();
      return !value || value.trim() === '';
    });
  };

  static transformPropertyName = (object, oldProperty, newProperty) => {
    if (!object) return {}; // Gestisci oggetto nullo
    const transformedObject = { ...object };

    if (Object.prototype.hasOwnProperty.call(transformedObject, oldProperty)) { // Modo più sicuro per hasOwnProperty
        transformedObject[newProperty] = transformedObject[oldProperty];
        delete transformedObject[oldProperty];
    }
    return transformedObject;
  };

  static generatePassword = () => {
    const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
    const specialChars = '!@#$%^&*()-_=+[{]};:<>|./?';
    const numbers = '0123456789';

    const getRandomChar = (charSet) => {
        if (!charSet || charSet.length === 0) return ''; // Gestisci charSet vuoto
        const randomIndex = Math.floor(Math.random() * charSet.length);
        return charSet[randomIndex];
    };

    let password = '';
    password += getRandomChar(uppercaseChars);
    password += getRandomChar(lowercaseChars);
    password += getRandomChar(specialChars);
    password += getRandomChar(numbers);

    const allChars = uppercaseChars + lowercaseChars + specialChars + numbers;
    const remainingLength = Math.max(0, 8 - password.length); // Assicura che non sia negativo

    for (let i = 0; i < remainingLength; i++) {
        password += getRandomChar(allChars);
    }
    // Mescola la password per una maggiore casualità
    password = password.split('').sort(() => Math.random() - 0.5).join('');
    return password;
  };

  static formatDateFillInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  static generateCourseCode() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const charactersLength = characters.length;
    let code = '';
    for (let i = 0; i < 16; i++) {
      code += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return code;
  }

  static generateIconContenuti(contenuto) {
    // Se questo file è .js e non .jsx, e usi un setup che non traspila JSX in file .js,
    // potresti dover restituire stringhe di classi o usare React.createElement.
    // Se usi <span className="...">, assicurati che React sia importato in cima al file.
    switch (contenuto?.tipo_contenuto) {
      case 'testo-immagini':
        return <span className="bi bi-file-earmark-font text-dark"></span>;
      case 'audio-video':
        return <span className="bi bi-file-earmark-play text-dark"></span>;
      case 'pdf':
        return <span className="bi bi-file-earmark-pdf"></span>;
      case 'test':
        return <span className="bi bi-file-earmark-text"></span>;
      default:
        return <span className="bi bi-file-earmark-font text-dark"></span>; 
    }
  }

} // Parentesi graffa finale che chiude la classe UtilityService